import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ItemsAdd from "./ItemsAdd";
import moment from "moment";
import Capital from "./Capital";
import Select from "react-select";

function Add(props) {
  const [formData, setFormData] = useState({
    orderDate: new Date(), // Current date
    deliveryDate: null,
    vendorName: "",
    deliveryPeriod: "",
    termsOfPayment: "",
    shippingLocation: "",
    billingAddress: "",
    remark: "",
    rmcode: "",
  });
  const [selectedCer, setselectedCer] = useState(null);
  const [isEdit, setisEdit] = useState(false);
  const [deletedItems, setDeletedItems] = useState([]);
  const [deliveryDateError, setDeliveryDateError] = useState(false);

  const [items, setItems] = useState([
    {
      itemName: "",
      noOfPackages: "",
      hsnCode: "",
      price: "",
      qty: "",
      unit: "",
      disc: "",
      amount: "",
    },
  ]);
  const [validated, setValidated] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [total, setTotal] = useState(0);
  const [isActive, setIsActive] = useState("");
  const statusList = [
    { id: "", name: "Select an option..." },
    { id: "1", name: "Active" },
    { id: "0", name: "Inactive" },
  ];
  const [gstColletion, setGstColletion] = useState({
    packing: "",
    transportation: "",
    other: "",
  });
  const [shippingLocations, setShippingLocations] = useState([]);
  const [billingAddresses, setBillingAddresses] = useState([]);

  useEffect(() => {
    getVendors();
    getOfficeLocation();
    getBilling();
  }, []);

  const getVendors = () => {
    utils
      .callAPI(
        "get",
        `/vendors/listAll?created_by=&company_name=&name=&contact_no=&gst_no=&state=&deal_item=`
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          const activeVendors = res.result.filter(
            (vendor) => vendor.status === "1"
          );
          setVendors([
            { id: "", companyName: "Select Vendor..." },
            ...activeVendors,
          ]);
        }
      })
      .catch(() => {
        setVendors([]);
      });
  };

  const getOfficeLocation = () => {
    utils
      .callAPI("get", `/sales/getLocationList`)
      .then((res) => {
        if (typeof res !== "undefined") {
          // const activeVendors = res.result.filter(
          //   (vendor) => vendor.status === '1'
          // );
          setShippingLocations([
            { id: "", name: "Select Shipping Location..." },
            ...res.result,
          ]);
        }
      })
      .catch(() => {
        setShippingLocations([]);
      });
  };

  const getBilling = () => {
    utils
      .callAPI(
        "get",
        `/billinglocation/list?page=${0}&per_page=${0}&company_name&status=1`
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          console.log(res?.result);
          setBillingAddresses([
            { id: "", company_name: "Select Billing Location..." },
            ...res.result,
          ]);
        } else {
          setBillingAddresses([]);
        }
      })
      .catch((err) => {
        setBillingAddresses([]);
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    const isDeliveryDateValid = !!formData.deliveryDate;
    setDeliveryDateError(!isDeliveryDateValid);

    if (form.checkValidity() === false || !isDeliveryDateValid) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    setIsSubmit(true);
    setValidated(false);
  };

  useEffect(() => {
    if (isSubmit) {
      const transformedData = transformItems(items);
      const deleteItem = transformItems(deletedItems);
      var bodyFormData = new FormData();
      if (props.rowData && Object.keys(props.rowData).length > 0) {
        bodyFormData.append("id", props.rowData.id);
      }
      bodyFormData.append(
        "head_id",
        props.rowData && Object.keys(props.rowData).length > 0
          ? props.rowData.head_id
          : props.currentOrder.id
      );
      bodyFormData.append("cer_id", selectedCer ? selectedCer?.value : "");

      bodyFormData.append(
        "order_date",
        moment(formData.orderDate).format("YYYY-MM-DD")
      );
      bodyFormData.append(
        "delivery_date",
        moment(formData.deliveryDate).format("YYYY-MM-DD")
      );
      bodyFormData.append("vendor_id", formData.vendorName);
      bodyFormData.append("delivery_period", formData.deliveryPeriod);
      bodyFormData.append("terms_of_payment", formData.termsOfPayment);
      bodyFormData.append("shipping_location", formData.shippingLocation);
      bodyFormData.append("billing_address", formData.billingAddress);
      bodyFormData.append("total_amt", total);
      bodyFormData.append("remarks", formData.remark);
      bodyFormData.append("isActive", isActive);
      bodyFormData.append("rm_code", formData.rmcode);
      bodyFormData.append("packing_charge", gstColletion.packing);
      bodyFormData.append("transport_charge", gstColletion.transportation);
      bodyFormData.append("other_charge", gstColletion.other);
      bodyFormData.append("po_items", JSON.stringify(transformedData));
      bodyFormData.append(
        "delete_po_items",
        deleteItem.length !== 0 ? JSON.stringify(deleteItem) : ""
      );
      utils
        .callAPI("post", `/purchaseorder/save`, bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
            setIsSubmit(false);
          } else {
            setIsSubmit(false);
          }
        })
        .catch((err) => {
          setIsSubmit(false);
        });
    }
  }, [isSubmit]);

  const transformItems = (data) => {
    const transformedData = data.map((info) => ({
      id: info.id ? info.id : 0,
      item_id: info.itemName,
      hsn_code: info.hsnCode,
      no_of_packages: info?.noOfPackages ?? "0",
      price: info.price,
      qty: info.qty,
      unit: info.unit,
      // disc: info.disc,
      amount: info.amount,
      // is_delete: info.isDelete ? true : false,
      cgst_per: info?.cgst ? info?.cgst : "",
      cgst_amt: info?.cgstAmt ? info?.cgstAmt : "",
      sgst_per: info?.sgst ? info?.sgst : "",
      sgst_amt: info?.sgstAmt ? info?.sgstAmt : "",
      igst_per: info?.igst ? info?.igst : "",
      igst_amt: info?.igstAmt ? info?.igstAmt : "",
    }));

    return transformedData;
  };

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      setisEdit(true);

      setFormData({
        orderDate: new Date(props.rowData.order_date),
        deliveryDate: new Date(props.rowData.delivery_date),
        vendorName: props.rowData.vendor_id,
        deliveryPeriod: props.rowData.delivery_period,
        termsOfPayment: props.rowData.terms_of_payment,
        shippingLocation: props.rowData.shipping_location,
        billingAddress: props.rowData.billing_id,
        remark: props.rowData.remarks,
        rmcode: props?.rowData?.rm_code,
      });

      const transformedItems = props.rowData.po_items
        .slice()
        .reverse()
        .map((item) => ({
          id: item.id,
          itemName: item.item_id,
          // itemName: item.product_name,
          noOfPackages: item?.no_of_packages,

          hsnCode: item.hsn_code,
          price: item.price,
          qty: item.qty,
          unit: item.unit,
          disc: item.disc,
          amount: parseFloat(item.amount),
          cgst: item?.cgst_per ? item?.cgst_per : "",
          cgstAmt: item?.cgst_amt ? item?.cgst_amt : "",
          sgst: item?.sgst_per ? item?.sgst_per : "",
          sgstAmt: item?.sgst_amt ? item?.sgst_amt : "",
          igst: item?.igst_per ? item?.igst_per : "",
          igstAmt: item?.igst_amt ? item?.igst_amt : "",
        }));

      setItems(transformedItems);
      setTotal(props.rowData.total_amt);
      setIsActive(props.rowData.isActive);
    } else {
      setisEdit(false);
    }
  }, [props.rowData]);

  const handleStatusChange = (event) => {
    setIsActive(event.target.value);
  };

  const vendorOptions = vendors.map((vendor) => ({
    value: vendor.id,
    label: vendor.companyName,
  }));

  return (
    <div className="section-body">
      <RB.Card className="card shadow">
        <RB.Card.Header className="border-0">
          <h4>
            {!isEdit
              ? `Add ${props?.currentOrder?.head_name}`
              : `Edit ${props?.rowData?.head_name}`}
          </h4>
          <div className="card-header-action">
            <Link
              className="btn btn-underline me-2"
              onClick={props.onBackClick}
            >
              Back
            </Link>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <RB.Row>
              {console.log(props?.currentOrder)}
              {props?.currentOrder?.head_name == "Capital" && (
                <Capital
                  props={props}
                  selectedCer={selectedCer}
                  setselectedCer={setselectedCer}
                />
              )}
              <RB.Col md={6}>
                <div className="mb-3">
                  {/* <label>Order Date</label> */}
                  <DatePicker
                    selected={formData.orderDate}
                    onChange={(date) =>
                      setFormData({ ...formData, orderDate: date })
                    }
                    className="form-control"
                    // maxDate={new Date()}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="Select Order Date"
                    required
                  />
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div
                  className={`mb-3 ${
                    props?.currentOrder?.head_name == "Capital" ? "mt-3" : ""
                  }`}
                >
                  <DatePicker
                    selected={formData.deliveryDate}
                    onChange={(date) => {
                      setFormData({ ...formData, deliveryDate: date });
                      setDeliveryDateError(false); // clear error on change
                    }}
                    className={`form-control ${
                      deliveryDateError ? "is-invalid" : ""
                    }`}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="Select Delivery Date"
                    required
                  />
                  {deliveryDateError && (
                    <div className="invalid-feedback d-block">
                      Please select a delivery date.
                    </div>
                  )}
                </div>
              </RB.Col>
              <RB.Col className="mt-3" md={6}>
                <div>
                  <Select
                    options={vendorOptions}
                    className="bom-productName-select"
                    value={vendorOptions.find(
                      (v) => v.value === formData.vendorName
                    )}
                    onChange={(selected) =>
                      setFormData({
                        ...formData,
                        vendorName: selected?.value || "",
                      })
                    }
                    isClearable
                    placeholder=""
                    classNamePrefix="react-select"
                  />
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formDeliveryPeriod"
                    label="Delivery Period"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Delivery Period"
                      name="deliveryPeriod"
                      value={formData.deliveryPeriod}
                      onChange={handleInputChange}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formTermsOfPayment"
                    label="Terms of Payment"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Terms of Payment"
                      name="termsOfPayment"
                      value={formData.termsOfPayment}
                      onChange={handleInputChange}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formShippingLocation"
                    label="Shipping Location"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      as="select"
                      name="shippingLocation"
                      value={formData.shippingLocation}
                      onChange={handleInputChange}
                      required
                    >
                      {shippingLocations.map((location) => (
                        <option key={location.id} value={location.id}>
                          {location.name}
                        </option>
                      ))}
                    </RB.Form.Control>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formBillingAddress"
                    label="Billing Address"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      as="select"
                      name="billingAddress"
                      value={formData.billingAddress}
                      onChange={handleInputChange}
                      required
                    >
                      {billingAddresses.map((address) => (
                        <option key={address.id} value={address.id}>
                          {address.company_name}
                        </option>
                      ))}
                    </RB.Form.Control>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formTermsOfPayment"
                    label="RM Code"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="RM Code"
                      name="rmcode"
                      value={formData.rmcode}
                      onChange={handleInputChange}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="isActive"
                    label="Status"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      as="select"
                      value={isActive}
                      onChange={handleStatusChange}
                      required
                    >
                      {statusList.map((status) => (
                        <option key={status.id} value={status.id}>
                          {status.name}
                        </option>
                      ))}
                    </RB.Form.Control>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={12}>
                <ItemsAdd
                  items={items}
                  setItems={setItems}
                  setTotal={setTotal}
                  isEdit={isEdit}
                  setDeletedItems={setDeletedItems}
                  setGstColletion={setGstColletion}
                  propdata={props}
                />
              </RB.Col>

              <RB.Col md={12}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formRemark"
                    label="Remark"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      as="textarea"
                      placeholder="Enter remarks"
                      name="remark"
                      value={formData.remark}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>
            <RB.Row className="align-items-center mt-3">
              <RB.Col className="col-auto">
                <RB.Button variant="primary" type="submit">
                  Submit
                </RB.Button>
              </RB.Col>
            </RB.Row>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default Add;
